<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <usuario-agregar-form @success="success"></usuario-agregar-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <usuario-agregar-form @success="success"></usuario-agregar-form>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'usuario-agregar-form': require('./UsuarioAgregarForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
